const React = require('react');

class Post extends React.Component {
    render () {
        return (
            <div>
                <h1>Login</h1>
                <p>This is a static website, there is no login required.</p>
                <table>
                    <tr>
                        <td><input type="text" name="login" placeholder="login" disabled="disabled" /></td>
                    </tr>
                    <tr>
                        <td> <input type="text" name="password" placeholder="password" /></td>
                    </tr>
                </table>
            </div>
        )
    }
}

export default Post

exports.data = {
    title: "Login",
    path: "/login"
};



// WEBPACK FOOTER //
// ./login/index.js